module.exports = __webpack_public_path__ + "static/img/wisdomvalue.201d4d26.png";